var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ais-menu-select", {
    attrs: {
      attribute: _vm.attribute,
      "transform-items": _vm.transformItems,
      limit: _vm.limit,
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ items, canRefine, refine }) {
          return [
            _c(
              "ci-fe-wrapper",
              {
                attrs: {
                  label: _vm.label,
                  disabled: !canRefine,
                  value: _vm.initialize(items),
                },
              },
              [
                _c("v-select", {
                  staticClass: "ci-form--input",
                  attrs: {
                    label: "label",
                    options: items,
                    searchable: !_vm.$root.handheld,
                    value: _vm.internalValue,
                    disabled: !canRefine,
                    reduce: _vm.mapToValues,
                  },
                  on: {
                    input: function ($event) {
                      return _vm.handleInput($event, refine)
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "open-indicator",
                        fn: function ({ attributes }) {
                          return [
                            _c(
                              "span",
                              _vm._b(
                                { staticClass: "mdi mdi-chevron-down text-lg" },
                                "span",
                                attributes,
                                false
                              )
                            ),
                          ]
                        },
                      },
                      {
                        key: "option",
                        fn: function (option) {
                          return [
                            _c("div", { staticClass: "d-flex" }, [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "ci-truncated",
                                      rawName: "v-ci-truncated",
                                    },
                                  ],
                                  staticClass: "flex-grow-1 text-truncate",
                                },
                                [_vm._v(_vm._s(option.label))]
                              ),
                              _c("span", { staticClass: "truncated-hover" }, [
                                _vm._v(_vm._s(option.label)),
                              ]),
                              _vm.showCount
                                ? _c("span", { staticClass: "flex-shrink-0" }, [
                                    _vm._v("(" + _vm._s(option.count) + ")"),
                                  ])
                                : _vm._e(),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }